import React from 'react';
import { RxCross2 } from 'react-icons/rx';
import { User } from '../Types/User';
import { Avatar } from './Avatar';

interface CoAuthorTagProps {
  coAuthor: User;
  allowRemove?: boolean;
  onRemove?: (e: React.MouseEvent) => void;
}

/**
 * A component that displays a co-author tag with the user's avatar and name
 */
export const CoAuthorTag: React.FC<CoAuthorTagProps> = ({
  coAuthor,
  onRemove,
  allowRemove = false,
}) => {
  const handleRemove = (e: React.MouseEvent) => {
    e.stopPropagation();
    onRemove?.(e);
  };

  return (
    <div className="flex self-start items-center gap-1 px-3 py-1 rounded-full bg-purple-100 text-purple-700 text-sm">
      <Avatar user={coAuthor} size={24} />
      <span>Creating with</span>
      <span className="font-semibold">
        {coAuthor.name} {coAuthor.surname}
      </span>
      {allowRemove && (
        <button
          onClick={handleRemove}
          className="flex ml-1 items-center justify-center w-5 h-5 bg-purple-500 hover:bg-purple-600 rounded-full focus:outline-none"
        >
          <RxCross2 size={12} className="text-white font-bold" />
        </button>
      )}
    </div>
  );
};

export default CoAuthorTag;
